import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { reject } from 'q';


@Injectable()
export class NotificationService {

  public notify = {
    associateId: '',
    message: '',
    type: '',

    avatarUrl: '',
    actionUrl: '',
  }

  private action= {
    objectID: {},
    validationField: {},
    changes: [],
    type: '',
    message: '',
    actionUrl: '',
    category: '',
    receiverID: '',
    avatarUrl: '',
    acceptValue: '',
    rejectValue: '',
    status: 'Unread'}


  constructor(
    private _http: HttpClient,
    private config: Configuration,
  ) { }

/*
example notification:
[ Associate Organization Workgroup ListManagement Birthday]
message='You have been added to a workgroup <span class='fw-bold'>Workgroup Name</span> created by <a class='d-inline'>Asad Raza</a>'
associateId='whom to send notification'
Note: If you want to send notification to all Admin users just pass 'Admin' as a string in the 'associateId' field.
*/
  sendNotification(associateId: any, message: any, type: any, actionUrl: string, avatarUrl?: string): Promise<any> {
    this.notify.associateId = associateId;
    this.notify.message = message;
    this.notify.type = type;
    this.notify.avatarUrl = avatarUrl;
    this.notify.actionUrl = actionUrl;
    return new Promise(resolve => {
      this._http.post(`${this.config.ServerApiUrl}/notification/create`, this.notify).subscribe(res => {
        resolve(res)
      });
    })
  }


  /*
  actions types [Associate Organization Workgroup]
  example actionMessage:
  message='New workgroup <span class='fw-bold'>Workgroup Name</span> has been created by <a class='d-inline'>
  Asad Raza</a> need your approval. click here.'
  actionUrl='/home/working-group/profile-hr/123123132132'
  associateId='Who will perform action associate-HR id and able to see this'
  avatarUrl='assets/img/blank.png' if type is Associate and avatarUrl of person who perform changes.
  categories are  'Validation', 'Approval', 'Update'
  Note: If you want to send notification to all Admin users just pass 'Admin' as a string in the 'associateId' field.
  */
  // tslint:disable-next-line:max-line-length
  sendActionMessage(receiverID: any, message: any, actionUrl: any, category: any, type: any, acceptValue?: any, rejectValue?: any, objectID?: any, validationField?:any, changesArray?: any , avatarUrl?: any): Promise<any> {
    this.action.receiverID = receiverID;
    this.action.message = message;
    this.action.actionUrl = actionUrl;
    this.action.type = type;
    this.action.category = category;
    this.action.avatarUrl = avatarUrl;
    this.action.objectID = objectID;
    this.action.validationField = validationField;
    this.action.changes = changesArray;
    this.action.acceptValue = acceptValue;
    this.action.rejectValue = rejectValue;

    return new Promise((resolve,reject) => {
      this._http.post(`${this.config.ServerApiUrl}/actionCenter/create`, this.action).subscribe(res => {
        resolve(res);
      }, err => {
        console.log(err);
        reject(err)
      });
    })
  }


  public sendEmail(email: any, subject: any, message: any): Promise<any> {
    let mail = {
      email: email,
      subject: subject,
      message: message
    }

    return new Promise( (resolve,reject) => {
        this._http.post(`${this.config.ServerApiUrl}/sendEmail`, mail).subscribe(res => {
          console.log('email response service', res)
          resolve(res)
        }, err => {
          console.log('email reject service', err)
          reject(err);
        });
    })
  }

  public sendWelcomeEmail(emails: Array<any>, users: Array<any>): Promise<any> {

    return new Promise( (resolve,reject) => {
        this._http.post(`${this.config.ServerApiUrl}/associate/bulkWelcomeEmails`,{emails:emails,users:users}).subscribe(res => {
          console.log('email response service', res)
          resolve(res)
        }, err => {
          console.log('email reject service', err)
          reject(err);
        });
    })
  }

  public readAllunreadAction(associateId){
    this._http.post(`${this.config.ServerApiUrl}/actionCenter/newCounterToZero`,{associateId:associateId}).subscribe(res => {
      console.log(res)
    }, err => {
      console.log(err)
    });
  }

  public readAllunreadNotifications(associateId){
    this._http.post(`${this.config.ServerApiUrl}/notification/newCounterToZero`,{associateId:associateId}).subscribe(res => {
      console.log('response',res)
    }, err => {
      console.log('err',err)
    });
  }
}
